import { Space, Text } from '@billy/design-system'
import { ElementType, PropsWithChildren, ReactElement } from 'react'

import { getImageClassName } from '../../../../utils/getClassName'
import * as Styled from './styles'

interface EInvoicingGenericStatusProps {
  fullWidth?: boolean
  illustration?: ElementType
  title: string
}

export const EInvoicingGenericStatus = ({
  fullWidth = false,
  illustration: Illustration,
  title,
  children,
}: PropsWithChildren<EInvoicingGenericStatusProps>): ReactElement => {
  return (
    <Styled.StatusContainer>
      <Styled.StatusContent fullWidth={fullWidth}>
        <Space size="s16" />
        {Illustration && (
          <Styled.IllustrationContainer>
            <Illustration className={getImageClassName()} />
          </Styled.IllustrationContainer>
        )}
        <Space size="s16" />
        <Text variant="h1" alignment="center">
          {title}
        </Text>
        <Space size="s16" />
        {children}
      </Styled.StatusContent>
    </Styled.StatusContainer>
  )
}
